import React, { useState } from 'react'
import '../Styles/TopBar.css'
import { Link } from 'react-router-dom'


const TopBar = () => {
    const [active,setActive]=useState(0)
  return (
    <div className='top-bar'>
       <Link to="/" className="nav-tab-link">
        <h3 className={ active===0 ? 'topbar-content-active':'topbar-content'} onClick={()=>setActive(0)}>For Individuals</h3>
        </Link>
        <Link to="/for-businesses" className="nav-tab-link">
        <h3 className={ active===1 ? 'topbar-content-active':'topbar-content'} onClick={()=>setActive(1)}>For Businesses</h3>
        </Link>
        <Link to="/for-universities" className="nav-tab-link">
       
        <h3 className={ active===2 ? 'topbar-content-active':'topbar-content'} onClick={()=>setActive(2)}>For Universities</h3>
        </Link>
        
    </div>
  )
}

export default TopBar